import React from 'react'
import "./RadioOption.scss";
import { Radio } from '@livingdesign/react';

function RadioOption({
    UNSAFE_className,
    groupName,
    onChange,
    a11yLabelledBy,
    label,
    description,
    value,
    checked,
    disabled,
}) {
  return (
    <div className='RadioOption-ld3-custom'>
        <Radio
            UNSAFE_className={UNSAFE_className}
            name={groupName}
            onChange={onChange}
            a11yLabelledBy={a11yLabelledBy}
            value={value}
            checked={checked}
            disabled={disabled}
        />
        <div className='radio-custom-label'>
            <span>{label}</span>
            {description && <span
                id={a11yLabelledBy}
                className='typo-1'
                style={{
                    paddingTop: "4px"
                }}
            >{description}</span>}
        </div>
    </div>
  )
}

export default RadioOption